import { render, staticRenderFns } from "./edit-form.vue?vue&type=template&id=40f141ba&scoped=true"
import script from "./edit-form.vue?vue&type=script&lang=js"
export * from "./edit-form.vue?vue&type=script&lang=js"
import style0 from "./edit-form.vue?vue&type=style&index=0&id=40f141ba&prod&lang=less"
import style1 from "./edit-form.vue?vue&type=style&index=1&id=40f141ba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f141ba",
  null
  
)

export default component.exports